import { jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet } from "react-native";
import { coreTheme, Text } from "@kolmeo/ui-core";
const FieldLimitLabel = ({ maxLength, currentLength }) => {
    const { palette } = coreTheme;
    return (_jsxs(Text, { variant: "textMedium10", color: palette.kolmeoBlack, textAlign: "right", style: { paddingTop: 6 }, children: [currentLength ?? 0, " / ", maxLength] }));
};
export default FieldLimitLabel;
const styles = StyleSheet.create({});
